import { LoaderFunctionArgs } from "react-router-dom";
import type { TRepairRequestItem } from "@/types/repair.type.ts";
import { RepairAPI } from "@/api";

export default async function loadRepairRequestDetail({
  params: { id },
}: LoaderFunctionArgs): Promise<TRepairRequestItem> {
  return RepairAPI.getRequestItem(id!);
}
